import React from "react";
import { Flex } from "@chakra-ui/react";
import { NUMBER_OF_INDICATORS } from "src/modules/station/constants";
import Indicator from "./Indicator";

const MAX_VALUE = 1;
const INDICATOR_RANGE = MAX_VALUE / NUMBER_OF_INDICATORS;

export default class NoiseIndicator extends React.Component {
  state = { volume: 0, numberOfActiveIndicators: 0 };

  componentDidMount = () => {
    const { noiseMeter } = this.props;
    noiseMeter.on("change", this.handleActivityUpdate);
  };

  componentWillUnmount = () => {
    this.unMounted = true;
    const { noiseMeter } = this.props;
    noiseMeter && noiseMeter.off("change", this.handleActivityUpdate);
  };

  handleActivityUpdate = (volume) => {
    if (this.unMounted) {
      return;
    }
    const previousNumberOfIndicators = this.state.numberOfActiveIndicators;

    const cappedVolume = Math.min(MAX_VALUE, volume);

    const numberOfActiveIndicators = Math.ceil(cappedVolume / INDICATOR_RANGE);

    if (previousNumberOfIndicators === numberOfActiveIndicators) return;

    this.setState({ numberOfActiveIndicators });
  };

  render() {
    const { numberOfActiveIndicators } = this.state;
    const {
      station = "parent",
      responsive = true,
      colorFirstTwoDots = false,
      mode
    } = this.props;

    let indicators = [];

    for (let i = 1; i <= NUMBER_OF_INDICATORS; i++) {
      indicators.push(
        <Indicator
          mode={mode}
          colorFirstTwoDots={colorFirstTwoDots}
          responsive={responsive}
          station={station}
          key={i}
          isActive={i <= numberOfActiveIndicators}
          id={i}
        />
      );
    }

    return <Flex>{indicators}</Flex>;
  }
}
